module.exports = __webpack_public_path__ + "static/media/360-tours-active.4aee8e5f.svg";